module.exports = __webpack_public_path__ + "img/login_and_signup_screen.7c5375b7.png";